import { gql } from '@apollo/client';
import { insuranceFragment, hotelFragment } from 'store/fragments';
import { booking, leg, product, passenger } from '../queries/GET_BOOKING';

export default gql`
  mutation makeLoyaltyPayment(
    $isDepositPayment: Boolean
    $isMissedDeparture: Boolean
    $isFlowForwardCapped: Boolean
    $accountId: ID
    $customerId: String
    $bookingReference: String!
    $cashValue: Int!
    $points: Int
    $currency: String!
    $sendConfirmationEmail: Boolean
    $membershipNumber: String
  ) {
    makeLoyaltyPayment(
      isDepositPayment: $isDepositPayment
      isMissedDeparture: $isMissedDeparture
      isFlowForwardCapped: $isFlowForwardCapped
      accountId: $accountId
      customerId: $customerId
      bookingReference: $bookingReference
      cashValue: $cashValue
      points: $points
      currency: $currency
      sendConfirmationEmail: $sendConfirmationEmail
      membershipNumber: $membershipNumber
    ) {
      reference

      ${booking}
    }
  }

  ${insuranceFragment}

  ${hotelFragment}

  ${leg}

  ${passenger}

  ${product}
`;
